import { useTranslation } from 'react-i18next';
import type { ContentFilter } from '../../config/content-types';
import { useHorizontalOverflow } from './useHorizontalOverflow';

const FILTERS: Array<{ id: ContentFilter; labelKey: 'library.filter.all' | 'library.filter.slide' | 'library.filter.video' | 'library.filter.assessment' }> = [
  { id: 'all', labelKey: 'library.filter.all' },
  { id: 'slide', labelKey: 'library.filter.slide' },
  { id: 'video', labelKey: 'library.filter.video' },
  { id: 'assessment', labelKey: 'library.filter.assessment' },
];

export interface TypeChipsProps {
  value: ContentFilter;
  onChange: (value: ContentFilter) => void;
}

// four pills overflow 260px, so the row scrolls sideways
export function TypeChips({ value, onChange }: TypeChipsProps) {
  const { t } = useTranslation('panels');
  const { ref, faded, measure } = useHorizontalOverflow();
  return (
    <div className="h-scroll lib-chips">
      <div className="h-scroll__track" ref={ref} onScroll={measure} role="group" aria-label={t('library.filter.label')}>
        {FILTERS.map((filter) => (
          <button type="button" key={filter.id} aria-pressed={value === filter.id} className={value === filter.id ? 'is-active' : ''} onClick={() => onChange(filter.id)}>{t(filter.labelKey)}</button>
        ))}
      </div>
      {faded ? <span className="h-scroll__fade" aria-hidden={true} /> : null}
    </div>
  );
}
